document.addEventListener('DOMContentLoaded', function () {
  var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-lightbox-trigger]'));
  if (!triggers.length) return;

  var lightbox = document.getElementById('wedding-gallery-lightbox');
  var lightboxImg = document.getElementById('wedding-gallery-lightbox-img');
  var lightboxCaption = document.getElementById('wedding-gallery-lightbox-caption');
  var closeBtn = lightbox.querySelector('.wedding-gallery-lightbox__close');
  var prevBtn = lightbox.querySelector('.wedding-gallery-lightbox__prev');
  var nextBtn = lightbox.querySelector('.wedding-gallery-lightbox__next');
  var currentIndex = 0;

  function openLightbox(index) {
    currentIndex = index;
    var trigger = triggers[currentIndex];
    lightboxImg.src = trigger.getAttribute('href');
    lightboxImg.alt = trigger.getAttribute('data-caption') || '';
    lightboxCaption.textContent = trigger.getAttribute('data-caption') || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function showNext() {
    openLightbox((currentIndex + 1) % triggers.length);
  }

  function showPrev() {
    openLightbox((currentIndex - 1 + triggers.length) % triggers.length);
  }

  triggers.forEach(function (trigger, index) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openLightbox(index);
    });
  });

  closeBtn.addEventListener('click', closeLightbox);
  nextBtn.addEventListener('click', showNext);
  prevBtn.addEventListener('click', showPrev);

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') showNext();
    if (e.key === 'ArrowLeft') showPrev();
  });
});